import { z } from 'zod';
import { BOM_ITEM_CONSTRAINTS } from './constraints.js';
export const bomItemNameSchema = z
    .string()
    .trim()
    .min(1, `${BOM_ITEM_CONSTRAINTS.name.label} is required.`)
    .max(BOM_ITEM_CONSTRAINTS.name.maxLength, `${BOM_ITEM_CONSTRAINTS.name.label} must be ${BOM_ITEM_CONSTRAINTS.name.maxLength} characters or fewer.`);
// Bounds match the Decimal(28,9) column's representable range: values below 1e-9 round to
// zero on write, and values at or above 1e9 risk overflowing the 28-digit precision.
export const bomQuantitySchema = z
    .number()
    .positive('Quantity must be greater than 0.')
    .min(0.000000001, 'Quantity must be at least 0.000000001.')
    .max(1_000_000_000, 'Quantity must be 1,000,000,000 or less.');
// Sign is only accepted on the exponent (e.g. `1e-3`) — a leading `+`/`-` on the mantissa would
// otherwise pass this gate but then diverge into a different error message at the .positive()
// check below, for no user-visible reason.
const DECIMAL_LITERAL_PATTERN = /^(\d+\.?\d*|\.\d+)([eE][+-]?\d+)?$/;
// FOOTGUN: keep as z.string() — RHF coerces empty number inputs to 0.
export const bomQuantityStringSchema = z.string().superRefine((value, context) => {
    const trimmed = value.trim();
    if (trimmed === '') {
        context.addIssue({ code: 'custom', message: 'Quantity is required.', path: [] });
        return;
    }
    if (!DECIMAL_LITERAL_PATTERN.test(trimmed)) {
        context.addIssue({ code: 'custom', message: 'Enter a valid quantity.', path: [] });
        return;
    }
    const numericValue = Number(trimmed);
    if (!Number.isFinite(numericValue)) {
        context.addIssue({ code: 'custom', message: 'Enter a valid quantity.', path: [] });
        return;
    }
    const result = bomQuantitySchema.safeParse(numericValue);
    if (!result.success) {
        context.addIssue({
            code: 'custom',
            message: result.error.issues[0]?.message ?? 'Invalid quantity.',
            path: [],
        });
    }
});
//# sourceMappingURL=item-form.js.map